/* =========================================================
   OLIJFOLIE DIRECT — PREMIUM THEME JS (v4)
   Same functionality, smoother & richer micro-interactions.
   ========================================================= */
(() => {
  'use strict';

  const $  = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1. Announcement rotation — legacy + v2
     Uses one global initializer so section scripts are not needed.
     --------------------------------------------------------- */
  const initAnnouncements = () => {
    $$('.od-announcement').forEach(bar => {
      const items = $$('.od-announcement__item', bar);
      if (items.length < 2 || bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      let index = 0;
      items[0].classList.add('is-active');
      window.setInterval(() => {
        items[index]?.classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index]?.classList.add('is-active');
      }, Number(bar.dataset.speed || 5) * 1000);
    });

    $$('.od-announcement-v2').forEach(bar => {
      if (bar.dataset.odRotationInitialized === 'true') return;
      const track = $('.od-announcement-v2__track', bar);
      const slides = $$('.od-announcement-v2__slide', bar);
      if (!track || slides.length < 2) return;
      bar.dataset.odRotationInitialized = 'true';

      let index = 0;
      let timer = null;
      let startX = 0;
      const autoplay = bar.dataset.autoplay === 'true';
      const pauseHover = bar.dataset.pauseHover === 'true';
      const speed = Math.max(2000, parseInt(bar.dataset.speed, 10) || 5000);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const update = (animate = true) => {
        track.style.transition = animate && !reduced
          ? 'transform .45s cubic-bezier(.22,.61,.36,1)'
          : 'none';
        track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      };

      const next = () => {
        index = index >= slides.length - 1 ? 0 : index + 1;
        update(true);
      };

      const prev = () => {
        index = index <= 0 ? slides.length - 1 : index - 1;
        update(true);
      };

      const stop = () => {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
      };

      const schedule = () => {
        stop();
        if (!autoplay || reduced || slides.length < 2 || bar.hidden) return;
        timer = window.setTimeout(() => {
          next();
          schedule();
        }, speed);
      };

      bar.querySelector('.od-announcement-v2__arrow--next')?.addEventListener('click', () => {
        next();
        schedule();
      });
      bar.querySelector('.od-announcement-v2__arrow--prev')?.addEventListener('click', () => {
        prev();
        schedule();
      });

      const close = bar.querySelector('.od-announcement-v2__close');
      close?.addEventListener('click', () => {
        bar.hidden = true;
        stop();
      });

      if (pauseHover) {
        bar.addEventListener('mouseenter', stop);
        bar.addEventListener('mouseleave', schedule);
      }

      bar.addEventListener('touchstart', e => {
        if (e.touches?.length) startX = e.touches[0].clientX;
        stop();
      }, { passive: true });

      bar.addEventListener('touchend', e => {
        const endX = e.changedTouches?.[0]?.clientX || startX;
        const diff = endX - startX;
        if (Math.abs(diff) > 45) diff < 0 ? next() : prev();
        schedule();
      }, { passive: true });

      update(false);
      schedule();
    });
  };

  /* ---------------------------------------------------------
     2. Sticky header shrink-on-scroll + header shadow
     --------------------------------------------------------- */
  const initStickyHeader = () => {
    const header = $('.od-site-header.is-sticky');
    if (!header) return;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (window.scrollY > 24) header.classList.add('is-stuck');
        else header.classList.remove('is-stuck');
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* ---------------------------------------------------------
     3. Mobile navigation (with smooth open/close)
     --------------------------------------------------------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-mobile-menu]');
    if (btn) {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-active', open);
      return;
    }
    // Close on outside click
    const panel = $('.od-mobile-panel.is-open');
    if (panel && !panel.contains(e.target) && !e.target.closest('[data-mobile-menu]')) {
      panel.classList.remove('is-open');
      const trigger = $('[data-mobile-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------------------------------------------------------
     4. Gallery switching
     --------------------------------------------------------- */
  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-od-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-od-gallery]');
    const main = $('[data-od-gallery-main]', gallery);
    if (!main) return;
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset || '';
    $$('[data-od-gallery-thumb]', gallery).forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  /* ---------------------------------------------------------
     5. Quantity controls
     --------------------------------------------------------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-od-qty]');
    if (!btn) return;
    const wrap = btn.closest('[data-od-qty-wrap]');
    const input = $('[data-od-qty-input]', wrap);
    if (!input) return;
    let value = parseInt(input.value || '1', 10) || 1;
    value += btn.dataset.odQty === 'plus' ? 1 : -1;
    input.value = Math.max(1, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------
     6. Product quick-buy destination
     Essential drawer / Shopify cart / Checkout.
     --------------------------------------------------------- */
  const initQuickBuy = () => {
    document.addEventListener('submit', async e => {
      const form = e.target.closest('[data-od-quick-buy], [data-od-main-product-buy]');
      if (!form) return;

      const button = form.querySelector('button[type="submit"]');
      const variantInput = form.querySelector('[name="id"]');
      const quantityInput = form.querySelector('[name="quantity"]');
      const action = form.dataset.odBuyAction || 'essential';
      const addUrl = form.dataset.cartAddUrl;
      const cartUrl = form.dataset.cartUrl;
      const checkoutUrl = form.dataset.checkoutUrl;
      const productRoot = form.closest('.od-product-page, .od-product-showcase');
      const variantSelect = productRoot?.querySelector('[data-od-product-variant-select]');
      const activeVariantId = variantSelect?.value || variantInput?.value;

      if (!button || !activeVariantId || !addUrl) return;

      e.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      const originalLabel = button.textContent;
      button.textContent = 'Bezig…';

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{
            id:Number(activeVariantId),
            quantity:Math.max(1, Number(quantityInput?.value || 1))
          }]})
        });
        if (!response.ok) throw new Error('add_failed');
        const added = await response.json();

        if (action === 'checkout' && checkoutUrl) {
          window.location.href = checkoutUrl;
          return;
        }

        if (action === 'cart' && cartUrl) {
          window.location.href = cartUrl;
          return;
        }

        if (cartUrl) {
          const cartResponse = await fetch(`${cartUrl}.js`, {headers:{'Accept':'application/json'}});
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          document.dispatchEvent(new CustomEvent('variant:add', {bubbles:true, detail:{items:added.items || [added], cart}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add', cart}}));
        }

        button.disabled = false;
        button.textContent = originalLabel;
      } catch (error) {
        button.disabled = false;
        button.textContent = originalLabel;
        console.error('OD quick buy failed',error);
      }
    });
  };

  /* ---------------------------------------------------------
     6. Sticky add-to-cart bar
     --------------------------------------------------------- */
  const initStickyBuy = () => {
    const bar = $('[data-od-sticky-buy]');
    const anchor = $('[data-od-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.05 });
    observer.observe(anchor);
  };

  /* ---------------------------------------------------------
     7. Reveal-on-scroll (IntersectionObserver + stagger)
     --------------------------------------------------------- */
  const initReveal = () => {
    const nodes = $$('[data-od-reveal]');
    if (!nodes.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(n => n.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = Number(el.dataset.odRevealDelay || 0);
        setTimeout(() => el.classList.add('is-revealed'), delay);
        io.unobserve(el);
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(n => io.observe(n));
  };

  /* ---------------------------------------------------------
     8. Light parallax for hero media (premium feel, performant)
     --------------------------------------------------------- */
  const initParallax = () => {
    if (prefersReduced) return;
    const heroImages = $$('.luxe-hero__image');
    if (!heroImages.length || !('IntersectionObserver' in window)) return;
    let ticking = false;
    const visibleHeros = new Set();
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const id = entry.target.dataset.parallaxId || (entry.target.dataset.parallaxId = Math.random().toString(36).slice(2));
        if (entry.isIntersecting) visibleHeros.add(id);
        else visibleHeros.delete(id);
      });
    }, { threshold: 0 });
    heroImages.forEach((img, i) => {
      img.dataset.parallaxId = 'h' + i;
      io.observe(img.closest('.luxe-hero') || img);
    });
    const onScroll = () => {
      if (ticking || !visibleHeros.size) return;
      ticking = true;
      requestAnimationFrame(() => {
        heroImages.forEach(img => {
          const hero = img.closest('.luxe-hero');
          if (!hero) return;
          const rect = hero.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const offset = Math.max(-60, Math.min(60, rect.top * -0.08));
          img.style.transform = `translate3d(0, ${offset}px, 0) scale(1.04)`;
        });
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  /* ---------------------------------------------------------
     9. Magnetic hover for primary buttons (subtle, premium)
     --------------------------------------------------------- */
  const initMagnetic = () => {
    if (prefersReduced || window.matchMedia('(hover: none)').matches) return;
    const candidates = $$('.od-btn, .luxe-hero__cta--primary, .luxe-hero__cta--secondary');
    candidates.forEach(btn => {
      let raf = null;
      btn.addEventListener('mousemove', e => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          btn.style.transform = `translate(${x * 0.10}px, ${y * 0.18 - 2}px)`;
        });
      });
      btn.addEventListener('mouseleave', () => {
        if (raf) cancelAnimationFrame(raf);
        btn.style.transform = '';
      });
    });
  };

  /* ---------------------------------------------------------
     10. Smooth-scroll for in-page anchors
     --------------------------------------------------------- */
  const initSmoothScroll = () => {
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href');
      if (!id || id === '#' || id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
    });
  };

  /* ---------------------------------------------------------
     11. Initialize everything
     --------------------------------------------------------- */
  document.addEventListener('shopify:section:load', () => {
    initAnnouncements();
  });

  document.addEventListener('shopify:block:select', () => {
    initAnnouncements();
  });

  const onReady = () => {
    initAnnouncements();
    initStickyHeader();
    initQuickBuy();
    initStickyBuy();
    initReveal();
    initParallax();
    initMagnetic();
    initSmoothScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
